import { Branding } from '../resources'; // adjust import path

export function applyBrandColorsFromBranding(branding: Branding) {
  const root = document.documentElement;
  const colorMap = {
    darkModePrimary: branding.darkModePrimaryColor ?? branding.stripeColors.colorPrimary,
    darkModeSuccess: "#4afc2d"

    // Below is an example of when we'd add more colours. For now, it's only darkModePrimary 
    // background: branding.stripeColors.colorBackground,
    // text: branding.stripeColors.colorSecondaryText,
    // border: branding.stripeColors.colorBorder,
    // danger: branding.stripeColors.colorDanger,
    // success: branding.stripeColors.badgeSuccessColorBackground,
  };

  Object.entries(colorMap).forEach(([key, value]) => {
    root.style.setProperty(`--${key}`, value);
  });
}
